import React, { useEffect, useState } from 'react';

import { submitPostForm } from '../../redux/slices/postsSlice';

import { AppDispatch } from '../../redux/store';
import ModalWrapper from '../ModalConstructor/ModalWrapper/ModalWrapper';
import ModalContainer from '../ModalConstructor/ModalContainer/ModalContainer';
import ModalHeader from '../ModalConstructor/ModalHeader/ModalHeader';
import ModalFooter from '../ModalConstructor/ModalFooter/ModalFooter';
import SecondaryButton from '../shared/Buttons/SecondaryButton/SecondaryButton';
import MainButton from '../shared/Buttons/MainButton/MainButton';
import { useDispatch } from 'react-redux';
import { skipPostFromReport, removePostFromReport } from '../../redux/slices/postsSlice';
import { useIntl } from 'react-intl';
import wizworkLogoText from '../../images/formimg.png';
import CustomInput from '../shared/CustomInput/CustomInput';
import useWindowDimensions from '../../hooks/widthHook';

type Props = {
    close: (_: boolean) => void;
};

const FormModal: React.FC<Props> = ({close}) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch<AppDispatch>();
  const [questionName, setQuestionName] = useState('');
  const [questionPurpose, setQuestionPurpose] = useState('');
  const [questionGrant, setQuestionGrant] = useState('');
  const [questionDocument, setQuestionDocument] = useState('');
  const [questionBudget, setQuestionBudget] = useState('');
  const [questionAsset, setQuestionAsset] = useState('');
  const [questionNeed, setQuestionNeed] = useState('');
  const [errors, setErrors] = useState<any>({});


  const actionFunc = async () => {
    if (questionName === '' || questionPurpose === '' || questionGrant === '' || questionDocument === '' || questionBudget === '' || questionAsset === '' || questionNeed === '') {
      const newErrors: any = {};
      if (questionName === '') {
        newErrors["questionName"] = { message: formatMessage({ id: 'required' }) };
      }
      if (questionPurpose === '') {
        newErrors["questionPurpose"] = { message: formatMessage({ id: 'required' }) };
      }
      if (questionGrant === '') {
        newErrors["questionGrant"] = { message: formatMessage({ id: 'required' }) };
      }
      if (questionDocument === '') {
        newErrors["questionDocument"] = { message: formatMessage({ id: 'required' }) };
      }
      if (questionBudget === '') {
        newErrors["questionBudget"] = { message: formatMessage({ id: 'required' }) };
      }
      if (questionAsset === '') {
        newErrors["questionAsset"] = { message: formatMessage({ id: 'required' }) };
      }
      if (questionNeed === '') {
        newErrors["questionNeed"] = { message: formatMessage({ id: 'required' }) };
      }

      setErrors(newErrors);
      return;
    }

    const data = {
      questionName,
      questionPurpose,
      questionGrant,
      questionDocument,
      questionBudget,
      questionAsset,
      questionNeed,
    }    

    dispatch(submitPostForm(data));
    return;
  }

  return (
    <ModalWrapper 
      width={(useWindowDimensions().width > 768) ? '600px' : '100%'}
      isMobile={(useWindowDimensions().width <= 768) && true}
      scroll={true}
    >
      <ModalContainer>
        <ModalHeader
          textHeader={formatMessage({ id: 'fromHeader' })}
          smallCross onClose={() => close(false)}
          style={{textAlign: 'center', width: '100%'}}
          textStyles={{textAlign: 'center', width: '100%'}}
          subTextStyles={{textAlign: 'center'}}
        />
        {/* <ModalContainer > */}
        
        <div style={{textAlign: 'center', width: '100%', display: "flex", justifyContent: "center", marginBottom: 10}}>
          <img src={wizworkLogoText} alt="logo" width={227} height={174} />
        </div>
        <div className="form-modal__body" style={{textAlign: 'center'}}>
          <div className="form-modal__body-text">
            <p dangerouslySetInnerHTML={{ __html: formatMessage({ id: 'formModalText' }) }} />
          </div>
        </div>

        <CustomInput
          errors={errors}
          label={formatMessage({ id: 'questionName' })}
          inputName="questionName"
          style={{marginTop: '15px'}}
          defaultValue={questionName}
          onChangeFunc={(value) => setQuestionName(value)}
        />
        <CustomInput
          errors={errors}
          label={formatMessage({ id: 'questionPurpose' })}
          inputName="questionPurpose"
          style={{marginTop: '10px'}}
          defaultValue={questionPurpose}
          onChangeFunc={(value) => setQuestionPurpose(value)}
        />
        <CustomInput
          errors={errors}
          label={formatMessage({ id: 'questionGrant' })}
          inputName="questionGrant"
          style={{marginTop: '10px'}}
          defaultValue={questionGrant}
          onChangeFunc={(value) => setQuestionGrant(value)}
        />
        <CustomInput
          errors={errors}
          label={formatMessage({ id: 'questionDocument' })}
          inputName="questionDocument"
          style={{marginTop: '10px'}}
          defaultValue={questionDocument}
          onChangeFunc={(value) => setQuestionDocument(value)}
        />
        <CustomInput
          errors={errors}
          label={formatMessage({ id: 'questionBudget' })}
          inputName="questionBudget"
          style={{marginTop: '10px'}}
          defaultValue={questionBudget}
          onChangeFunc={(value) => setQuestionBudget(value)}
        />
        <CustomInput
          errors={errors}
          label={formatMessage({ id: 'questionAsset' })}
          inputName="questionAsset"
          style={{marginTop: '10px'}}
          defaultValue={questionAsset}
          onChangeFunc={(value) => setQuestionAsset(value)}
        />
        <CustomInput
          errors={errors}
          label={formatMessage({ id: 'questionNeed' })}
          inputName="questionNeed"
          style={{marginTop: '10px'}}
          defaultValue={questionNeed}
          onChangeFunc={(value) => setQuestionNeed(value)}
        />
        {/* </ModalContainer> */}
        <ModalFooter>
          <MainButton
            text={formatMessage({ id: "submit" })}
            onClick={() => actionFunc()}
            bigPadding  
          />
          <SecondaryButton text={formatMessage({ id: 'cancel' })} onClick={() => close(false)} bigPadding />
        </ModalFooter>
      </ModalContainer>
    </ModalWrapper>
  );
};

export default FormModal;